import React from 'react';
import { Paper } from '@material-ui/core';
import Page from './Page';

const style = {
  content: {
    padding: 16,
  },
};

export default function Cadeaux() {
  return (
    <Page title="Recevoir mes cadeaux">
      <Paper style={style.content} square>
        <p>
          BloodyBattle est probablement le plus vieux serveur Minecraft francophone
          encore ouvert.<br />
          Créé en décembre 2011 par un jeune collégien sous la forme d{"'"}un
          serveur Faction hébergé sur sa propre machine (avec Hamachi).
        </p>
      </Paper>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Cadeaux.js